import { linkFields } from './link'

/**
 * Inline CTA Fragment
 *
 * Use this anywhere a CTA object lives directly on a document or block.
 */
export const inlineCtaFields = `
  title,
  action,
  "link": link{
    ${linkFields}
  },
  variant
`
